import { config } from "/app.config"
import { getUserProfile } from "@/services/UserService"

export const INTERCOM_APP_ID = process.env.VUE_APP_INTERCOM_APP_ID

export const isIntercomEnabled = () => {
  return INTERCOM_APP_ID && INTERCOM_APP_ID.length && config.isZeno
}

export const initializeIntercom = () => {
  if (!isIntercomEnabled()) {
    return
  }

  if (window?.Intercom) {
    bootIntercom()
    return
  }

  // eslint-disable-next-line no-extra-semi
  ;(function () {
    var w = window
    var ic = w.Intercom
    if (typeof ic === "function") {
      ic("reattach_activator")
      ic("update", w.intercomSettings)
    } else {
      var d = document
      var i = function () {
        i.c(arguments)
      }
      i.q = []
      i.c = function (args) {
        i.q.push(args)
      }
      w.Intercom = i
      var l = function () {
        var s = d.createElement("script")
        s.type = "text/javascript"
        s.async = true
        s.src = "https://widget.intercom.io/widget/" + INTERCOM_APP_ID
        s.onload = function () {
          bootIntercom()
        }
        var x = d.getElementsByTagName("script")[0]
        x.parentNode.insertBefore(s, x)
      }
      if (document.readyState === "complete") {
        l()
      } else if (w.attachEvent) {
        w.attachEvent("onload", l)
      } else {
        w.addEventListener("load", l, false)
      }
    }
  })()
}

export const trackIntercomEvent = (eventName, metadata = null) => {
  if (isIntercomEnabled() && window.Intercom) {
    if (metadata) {
      window.Intercom("trackEvent", eventName, metadata)
    } else {
      window.Intercom("trackEvent", eventName)
    }
  }
}

export const bootIntercom = async () => {
  if (isIntercomEnabled() && window.Intercom) {
    const profile = await getUserProfile()

    window.Intercom("boot", {
      app_id: INTERCOM_APP_ID,
      email: profile.email,
      user_hash: profile.intercomToken,
      vertical_padding: 85,
    })

    window.Intercom("update", {
      hide_default_launcher: false,
    })
  }
}

export const updateIntercom = () => {
  if (isIntercomEnabled() && window.Intercom) {
    window.Intercom("update")
  }
}

export const shutdownIntercom = () => {
  if (isIntercomEnabled() && window.Intercom) {
    window.Intercom("shutdown")
  }
}
